import { css } from "@emotion/react";
import SearchInCompassIcon from "./SearchInCompassIcon";
import BookshelfIcon from "../../icons/compass.svg?react";

const Header = () => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        margin: 0 0 13px;
        padding: 16px 16px 16px 20px;
        box-shadow:
          0 1px 2px -1px rgba(0, 0, 0, 0.1),
          0 1px 3px 0 rgba(0, 0, 0, 0.1);
      `}
    >
      <div
        css={({ colours }) => css`
          display: flex;
          align-items: center;
          gap: 8px;
          font-weight: 600;
          font-size: 28px;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.25;
          letter-spacing: normal;
          color: ${colours.primary.mid.dark20};
        `}
      >
        <BookshelfIcon />
        Insight
      </div>

      <SearchInCompassIcon />
    </div>
  );
};

export default Header;
